// extracted by mini-css-extract-plugin
export default {"item":"JOWF2PUhpvLVEflsn3AhJw==","icon":"_5N4bXcfjsGNWf+BD4I4YaA=="};